import { Component, OnInit, Input } from '@angular/core';
import { Thread, ThreadReplierDetail } from '../../_shared/models';
import { CustomSnackbarComponent } from '../../_shared/layout';
import { TicketService, TicketAttachmentService } from '../../_shared/services';
import { MatSnackBar } from '@angular/material';
import { Granule } from '../../config';
import { saveAs as importedSaveAs } from 'file-saver';

@Component({
  selector: 'app-ticket-thread',
  templateUrl: './ticket-thread.component.html',
  styleUrls: [
    './ticket-thread.component.css',
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css'
  ]
})
export class TicketThreadComponent implements OnInit {
  @Input('detail') detail: Thread;
  @Input('threadReplierDetail') threadReplierDetail: ThreadReplierDetail;
  @Input('ticketid') ticketid: string;

  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;

  constructor(
    private granule: Granule,
    private ticketService: TicketService,
    private ticketAttachmentService: TicketAttachmentService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {}

  downloadAttachment(path: string, filename: string, ticket_id: string) {
    const data = {
      path_to_file: path,
      file_name: filename,
      ticket_id: ticket_id
    };

    this.ticketAttachmentService.downloadAttachment(data).subscribe(
      res => {
        importedSaveAs(res, filename);
      },
      error => {
        let data = {
          type: 'error',
          message: 'Error Downloading the File'
        };
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: data,
          duration: 5000
        });
      }
    );
  }

  downloadAllAttachments(thread_attachments: Array<any>, ticket_id: string) {
    let attachments = new Array<any>();

    for (let attachment of thread_attachments) {
      attachments.push(attachment.hashedfilename);
    }

    const data = {
      thread_attachments: attachments,
      ticket_id: ticket_id
    };

    this.ticketAttachmentService.downloadAttachment(data).subscribe(
      res => {
        importedSaveAs(res, ticket_id);
      },
      error => {
        let data = {
          type: 'error',
          message: 'Error Downloading the Zip'
        };
        this.snackBar.openFromComponent(CustomSnackbarComponent, {
          data: data,
          duration: 5000
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/ticket-thread/ticket-thread.component.ts